function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-902 -433)",
  fill: "#95A0B3"
}, /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  transform: "translate(216 200)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(360 220)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-GAP-/-16-/-Silverware",
  transform: "translate(322 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 3a1 1 0 011 1v12a1 1 0 01-2 0v-4l-1-1V7c.234-1.325.567-2.325 1-3 .327-.49.66-.824 1-1zm-9 7a2 2 0 01-2-2V3.5a.5.5 0 011 0V8h1V4a1 1 0 112 0v4h1V3.5a.5.5 0 011 0V8a2 2 0 01-2 2v6a1 1 0 01-2 0v-6z",
  id: "Silverware"
}))))))));